import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useTimezones } from 'hb-react/shared/hooks/useTimezones';

const ReactSelectTimezones = ({ options = [], placeholder, ...props }) => {
  const { isLoading, data: timezoneOptions } = useTimezones();

  return (
    <ReactSelectInput
      {...props}
      options={isEmpty(options) ? timezoneOptions : options}
      placeholder={placeholder || I18n.t('views.backoffice.timezone')}
      isLoading={isLoading}
    />
  );
};

ReactSelectTimezones.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  hasAsyncFetchingEnabled: PropTypes.bool,
};

export default ReactSelectTimezones;
